(function () {
  'use strict';

  // Section scripts can execute again after a Shopify theme-editor reload.
  if (window.DadBitesReviewSections) {
    window.DadBitesReviewSections.init(document);
    return;
  }

  function initSection(root) {
    if (root.dataset.dbReviewsReady) return;
    var grid = root.querySelector('[data-db-review-grid]');
    if (!grid) return;
    var entries = Array.from(grid.querySelectorAll('[data-db-review]')).map(function (node) {
      return { node: node, language: node.dataset.language, rating: Number(node.dataset.rating) };
    });
    if (!entries.length) return;

    var pageSize = Number(root.dataset.pageSize) || 6;
    var languageFilter = root.querySelector('[data-db-review-language]');
    var ratingFilter = root.querySelector('[data-db-review-rating]');
    var more = root.querySelector('[data-db-review-more]');
    var status = root.querySelector('[data-db-review-status]');
    var empty = root.querySelector('[data-db-review-empty]');
    var regional = window.DadBitesRegionalReviews;
    // An English storefront default should not erase the browser's language.
    var locale = root.dataset.shopifyLocale || '';
    var language = regional ? regional.resolveLanguage({
      shopifyLocale: /^en(?:-|$)/i.test(locale) ? null : locale,
      browserLanguages: navigator.languages || [navigator.language]
    }) : 'en';
    var seed = Math.floor(Math.random() * 100000);
    var ordered = [];
    var visible = pageSize;

    function rebuild() {
      var pool = entries.filter(function (entry) {
        return (languageFilter.value === 'all' || entry.language === languageFilter.value) &&
          (ratingFilter.value === 'all' || entry.rating === Number(ratingFilter.value));
      });
      ordered = [];
      // Order each displayed batch separately to keep the language mix useful.
      while (pool.length) {
        var batch = regional ? regional.orderReviews(pool, {
          language: languageFilter.value === 'all' ? language : languageFilter.value,
          limit: pageSize, localShare: 0.65, seed: seed
        }) : pool.slice(0, pageSize);
        if (!batch.length) batch = pool.slice(0, pageSize);
        ordered = ordered.concat(batch);
        pool = pool.filter(function (entry) { return batch.indexOf(entry) === -1; });
      }
      ordered.forEach(function (entry) { grid.appendChild(entry.node); });
      visible = pageSize;
      render();
    }

    function render() {
      entries.forEach(function (entry) { entry.node.hidden = true; });
      ordered.slice(0, visible).forEach(function (entry) { entry.node.hidden = false; });
      var shown = Math.min(visible, ordered.length);
      status.textContent = 'Showing ' + shown + ' of ' + ordered.length + ' reviews';
      empty.hidden = ordered.length > 0;
      more.hidden = shown >= ordered.length;
    }

    languageFilter.addEventListener('change', rebuild);
    ratingFilter.addEventListener('change', rebuild);
    more.addEventListener('click', function () { visible += pageSize; render(); });
    root.dataset.dbReviewsReady = 'true';
    root.querySelector('[data-db-review-controls]').hidden = false;
    rebuild();

    // Keep the product's headline rating consistent with these displayed reviews.
    var hero = document.querySelector('.dadbites-hero-rating');
    if (hero) {
      var average = entries.reduce(function (sum, entry) { return sum + entry.rating; }, 0) / entries.length;
      var link = document.createElement('a');
      link.className = 'db-reviews__hero-link';
      link.href = '#' + root.id;
      link.setAttribute('aria-label', average.toFixed(1) + ' out of 5 from ' + entries.length + ' unverified reviews. Read reviews.');
      var stars = document.createElement('span');
      stars.className = 'db-reviews__hero-stars';
      stars.setAttribute('aria-hidden', 'true');
      stars.textContent = '★';
      link.appendChild(stars);
      link.appendChild(document.createTextNode(average.toFixed(1) + '/5 · ' + entries.length + ' reviews'));
      hero.replaceChildren(link);
      hero.setAttribute('aria-label', 'Unverified review rating');
    }
  }

  function init(scope) {
    if (scope.matches && scope.matches('[data-db-reviews]')) initSection(scope);
    scope.querySelectorAll('[data-db-reviews]').forEach(initSection);
  }

  window.DadBitesReviewSections = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
